export enum YesNo {
  Yes = "Yes",
  No = "No",
}
